/**
 * CircuPack API
 * Rest API para acceder al sistema CircuPack
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Blister } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface ObtenerPautaPorBlisterTokenYRangoFechasRequestParams {
    xUUID: string;
    /** Token único para un blister */
    blisterToken: string;
    /** Filtro inicio rango fechas */
    fechaInicio: string;
    /** Filtro fin rango fechas */
    fechaFin: string;
}


@Injectable({
  providedIn: 'root'
})
export class PautaService {

    protected basePath = 'https://virtserver.swaggerhub.com/ovicenteabatura/CircuPack/0.0.1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Devuelve la pauta de medicación del paciente en base a un token de un blister, una fecha inicio y una fecha fin.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public obtenerPautaPorBlisterTokenYRangoFechas(requestParameters: ObtenerPautaPorBlisterTokenYRangoFechasRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Blister>;
    public obtenerPautaPorBlisterTokenYRangoFechas(requestParameters: ObtenerPautaPorBlisterTokenYRangoFechasRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Blister>>;
    public obtenerPautaPorBlisterTokenYRangoFechas(requestParameters: ObtenerPautaPorBlisterTokenYRangoFechasRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Blister>>;
    public obtenerPautaPorBlisterTokenYRangoFechas(requestParameters: ObtenerPautaPorBlisterTokenYRangoFechasRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const xUUID = requestParameters.xUUID;
        if (xUUID === null || xUUID === undefined) {
            throw new Error('Required parameter xUUID was null or undefined when calling obtenerPautaPorBlisterTokenYRangoFechas.');
        }
        const blisterToken = requestParameters.blisterToken;
        if (blisterToken === null || blisterToken === undefined) {
            throw new Error('Required parameter blisterToken was null or undefined when calling obtenerPautaPorBlisterTokenYRangoFechas.');
        }
        const fechaInicio = requestParameters.fechaInicio;
        if (fechaInicio === null || fechaInicio === undefined) {
            throw new Error('Required parameter fechaInicio was null or undefined when calling obtenerPautaPorBlisterTokenYRangoFechas.');
        }
        const fechaFin = requestParameters.fechaFin;
        if (fechaFin === null || fechaFin === undefined) {
            throw new Error('Required parameter fechaFin was null or undefined when calling obtenerPautaPorBlisterTokenYRangoFechas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (blisterToken !== undefined && blisterToken !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>blisterToken, 'blisterToken');
        }
        if (fechaInicio !== undefined && fechaInicio !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fechaInicio, 'fechaInicio');
        }
        if (fechaFin !== undefined && fechaFin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fechaFin, 'fechaFin');
        }

        let headers = this.defaultHeaders;
        if (xUUID !== undefined && xUUID !== null) {
            headers = headers.set('X-UUID', String(xUUID));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Blister>(`${this.configuration.basePath}/pauta`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
